import { DatasetsFilesInfo } from '@mygpt/app/datasets/services';
import { Http } from '@mygpt/app/http';

interface FAQDetailParams {
  faqId: string;
}

export interface ResourcesInfo {
  faq_id: string;
  id: string;
  page_numbers: [];
  vector_file: DatasetsFilesInfo;
  vector_file_id: string;
}

export interface FAQDetail {
  session_message_id: string;
  user_id: string;
  dataset_id: string;
  id: string;
  deleted_at: null;
  excel_id: null;
  answer: string;
  config_id: null;
  citation: null;
  robot_id: null;
  property_info: [];
  updated_at: string;
  sources: null;
  question: string;
  rating: number;
  created_at: string;
  type: string;
  resources: ResourcesInfo[];
  recommended_questions: string[];
  similar_questions: string[];
  is_search: boolean;
}

/**
 * 获取机器人问答列表
 * @param params
 * @returns
 */
export const faqsDetail = (params: FAQDetailParams) => {
  const { faqId } = params;
  const { get } = Http.use();
  return get<FAQDetail>(`/datasets/faqs/detailed/${faqId}`);
};
